import ReactGA from 'react-ga4';

const OPT_OUT_KEY = 'ai4us_analytics_opt_out';

export const isOptedOut = () => localStorage.getItem(OPT_OUT_KEY) === 'true';

export const setOptOut = (value) => {
    localStorage.setItem(OPT_OUT_KEY, String(value));
};

const enabled = () =>
    Boolean(process.env.REACT_APP_GA_MEASUREMENT_ID) && !isOptedOut();

export const trackPageView = (path) => {
    if (!enabled()) return;
    ReactGA.send({ hitType: 'pageview', page: path });
};

export const trackEvent = (name, params = {}) => {
    if (!enabled()) return;
    ReactGA.event(name, params);
};
